import { TFunction } from 'i18next'
import { ChargingMode } from 'src/Libs/flow/installation/forms'

/** Options for the charging modes of the evse-settings */
export const getChargingStationChargingModeOptions = (t: TFunction): Options<ChargingMode> => {
  return [
    {
      value: 'standard',
      label: t('installation.evseEditor.chargingStrategy.standard'),
      description: t('installation.evseEditor.chargingStrategy.standardDescription'),
    },
    {
      value: 'pvOnly',
      label: t('installation.evseEditor.chargingStrategy.pvOnly'),
      description: t('installation.evseEditor.chargingStrategy.pvOnlyDescription'),
    },
    {
      value: 'pvImmediate',
      label: t('installation.evseEditor.chargingStrategy.pvImmediate'),
      description: t('installation.evseEditor.chargingStrategy.pvImmediateDescription'),
    },
    {
      value: 'pvDelayed',
      label: t('installation.evseEditor.chargingStrategy.pvDelayed'),
      description: t('installation.evseEditor.chargingStrategy.pvDelayedDescription'),
    },
  ]
}
